// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071034/js/" + chunkId + "." + {"44":"00cc5471","225":"7507ed06","481":"81af9d46","486":"a131f14d","770":"9d0217f8"}[chunkId] + ".0.7886192487922461.chunk.js";
};